<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="saveEmailTemplate()">
          <div class="row">
            <div class="col-lg-12">
              <div class="float-right">
                <button type="button" class="btn btn-secondary mr-2" @click="popupEmailTest()">
                  <i class="mdi mdi-plus mr-1"></i> Enviar e-mail de teste
                </button>
                <a href="javascript:void(0)" @click="cancelar()" class="btn btn-dark mr-2">
                  Cancelar
                </a>
                <button type="submit" class="btn btn-primary mr-1">
                  Salvar
                </button>
              </div>
            </div>
          </div>
          <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Informações do E-mail</span>
                <b-badge
                  v-show="$v.emailtemplate.$error"
                  variant="danger"
                  class="float-right ml-2"
                >
                  Atenção!
                </b-badge>
              </template>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="from_name">De</label>
                    <input
                      type="text"
                      name="from_name"
                      id="from_name"
                      class="form-control"
                      v-model="emailtemplate.from_name"
                      :class="{'is-invalid': submitted && $v.emailtemplate.from_name.$error}"
                    >
                    <div v-if="submitted && !$v.emailtemplate.from_name.required" class="invalid-feedback">
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="subject">Assunto</label>
                    <input
                      type="text"
                      name="subject"
                      id="subject"
                      class="form-control"
                      v-model="emailtemplate.subject"
                      :class="{'is-invalid': submitted && $v.emailtemplate.subject.$error}"
                    >
                    <div v-if="submitted && !$v.emailtemplate.subject.required" class="invalid-feedback">
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="url_privacy_policy">Política de privacidade</label>
                    <input
                      type="text"
                      name="url_privacy_policy"
                      placeholder="URL política de privacidade"
                      id="url_privacy_policy"
                      class="form-control"
                      v-model="emailtemplate.url_privacy_policy"
                      :class="{'is-invalid': submitted && $v.emailtemplate.url_privacy_policy.$error}"
                    >
                    <div v-if="submitted && !$v.emailtemplate.url_privacy_policy.required" class="invalid-feedback">
                      O campo é obrigatório.
                    </div>
                  </div>
                </div>
              </div>

              <hr class="my-3">
              <h6 class="font-size-14 mb-3">Rodapé do E-mail</h6>
              <p class="text-muted font-size-12 mb-3">Essas informações aparecem no rodapé e ajudam na entregabilidade.</p>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="address_complete">Endereço</label>
                    <input type="text" class="form-control" id="address_complete" placeholder="ex: Av. Brasil, 152 - São Paulo, SP - Brasil" v-model="emailtemplate.address_complete">
                  </div>
                </div>
              </div>

            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-envelope"></i>
                </span>
                <span class="d-none d-sm-inline-block">Template</span>
              </template>

              <!-- Variaveis dinamicas -->
              <div class="var-bar">
                <span class="var-bar-label">
                  <i class="bx bx-code-curly"></i> Variaveis:
                </span>
                <span
                  v-for="tag in mergeTagsList"
                  :key="tag.value"
                  class="var-tag"
                  :title="tag.value + ' — clique para copiar'"
                  @click="copyVariable(tag.value)"
                >
                  {{ tag.label }} <code>{{ tag.value }}</code>
                </span>
              </div>

              <div class="col-lg-12" style="height: 1000px">
                <EmailEditor
                  :appearance="appearance"
                  :min-height="minHeight"
                  :project-id="projectId"
                  :locale="locale"
                  :options="options"
                  ref="emailEditor"
                  v-on:ready="editorReady"
                />
              </div>
            </b-tab>
          </b-tabs>
        </form>
      </div>
    </div>
    <modal-form v-model="modalForm" ref="formTestEmail"></modal-form>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import * as storage from '@/modules/auth/storage'
import modalForm from './EmailTest.vue'
import { EmailEditor } from 'vue-email-editor'
import service from './services'

export default {
  components: {
    Layout,
    PageHeader,
    modalForm,
    EmailEditor
  },
  name: 'templates',
  page: {
    title: 'Templates',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      minHeight: '1000px',
      height: '1000px',
      locale: 'pt-BR',
      projectId: 84022, // replace with your project id
      options: {
        features: {
          ai: false
        },
        version: '1.157.0',
        mergeTags: {
          nome: { name: 'Nome do Participante', value: '{$nome}' },
          email: { name: 'E-mail do Participante', value: '{$email}' },
          phone: { name: 'Telefone', value: '{$phone}' },
          nomedoevento: { name: 'Nome do Evento', value: '{$nomedoevento}' },
          urlacao: { name: 'URL Magic Link', value: '{$urlacao}', sample: 'https://link.exemplo.com' },
          dataexpiracao: { name: 'Data de Expiração', value: '{$dataexpiracao}', sample: '31/12/2026' },
          nomeregra: { name: 'Nome da Regra', value: '{$nomeregra}' }
        }
      },
      appearance: {
        theme: 'modern_light',
        panels: {
          tools: {
            dock: 'right'
          }
        }
      },
      loading: true,
      modalForm: false,
      submitted: false,
      emailtemplate: {
        from_name: '',
        from_email: 'eventos@mail.rsvpfy.com.br',
        subject: '',
        url_privacy_policy: '',
        address_complete: '',
        content: '',
        design: null
      },
      mergeTagsList: [
        { label: 'Nome', value: '{$nome}' },
        { label: 'E-mail', value: '{$email}' },
        { label: 'Telefone', value: '{$phone}' },
        { label: 'Evento', value: '{$nomedoevento}' },
        { label: 'URL Acao', value: '{$urlacao}' },
        { label: 'Expiracao', value: '{$dataexpiracao}' },
        { label: 'Regra', value: '{$nomeregra}' }
      ],
      formFieldTags: {},
      title: 'Novo Template de E-mail',
      items: [{
        text: 'E-mail',
        href: '/'
      },
      {
        text: 'Editar',
        active: true
      }
      ]
    }
  },
  validations: {
    emailtemplate: {
      from_name: { required },
      subject: { required },
      url_privacy_policy: { required }
    }
  },
  mounted () {
    // eslint-disable-next-line semi
    const copiedTemplate = this.copiedTemplate;
    if (copiedTemplate) {
      this.emailtemplate = {
        ...this.emailtemplate,
        ...copiedTemplate,
        id: undefined
      }
    }
    this.loadItem()
    this.loadVariables()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('emailTemplate', { data: 'emailtemplate', copiedTemplate: 'copiedTemplate' }),
    token () {
      return storage.getLocalToken()
    }
  },
  methods: {
    ...mapActions('emailTemplate', {
      fetch: 'show',
      createTemplate: 'create',
      destroyHeader: 'destroyHeader'
    }),
    saveDesign () {
      this.$refs.emailEditor.editor.saveDesign(
        (design) => {
          console.log('saveDesign', design)
          this.emailtemplate.design = design
        }
      )
    },
    exportHtml () {
      this.$refs.emailEditor.editor.exportHtml(
        (data) => {
          console.log('exportHtml', data)
        }
      )
    },
    editorLoaded () {
      if (this.emailtemplate.design) {
        this.$refs.emailEditor.editor.loadDesign(this.emailtemplate.design)
      } else {
        console.warn('Nenhum design disponível para carregar')
      }
    },
    renameMergeTagsLabel () {
      const editorEl = this.$refs.emailEditor && this.$refs.emailEditor.$el
      if (!editorEl) return
      const iframe = editorEl.querySelector('iframe')
      if (!iframe || !iframe.contentDocument) return

      const replaceText = (root) => {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false)
        let node
        while ((node = walker.nextNode())) {
          if (node.nodeValue && /mesclar\s*marcadores/i.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/mesclar\s*marcadores/gi, 'Variáveis')
          }
          if (node.nodeValue && node.nodeValue === 'Merge Tags') {
            node.nodeValue = 'Variáveis'
          }
        }
      }

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
      replaceText(iframeDoc.body)

      const observer = new MutationObserver(() => {
        replaceText(iframeDoc.body)
      })
      observer.observe(iframeDoc.body, { childList: true, subtree: true, characterData: true })
      this._mergeTagObserver = observer
    },
    editorReady () {
      if (this.emailtemplate.design) {
        try {
          this.$refs.emailEditor.editor.loadDesign(this.emailtemplate.design)
          console.log('Design carregado com sucesso')
        } catch (err) {
          console.error('Erro ao carregar design:', err)
        }
      } else {
        console.warn('Nenhum design disponível para carregar')
      }
      // Injeta as variáveis dos campos do form builder nas merge tags do editor.
      this.applyMergeTags()
      // Renomear "Mesclar marcadores" para "Variáveis" no iframe do Unlayer
      setTimeout(() => { this.renameMergeTagsLabel() }, 2000)
      setTimeout(() => { this.renameMergeTagsLabel() }, 4000)
      setTimeout(() => {
        this.$refs.emailEditor.editor.registerCallback('image', (file, done) => {
          const data = new FormData()
          data.append('file', file.attachments[0]) // Acessa o primeiro arquivo

          fetch(process.env.VUE_APP_DEFAULT_AUTH + '/admin/settings/email/uploadNew', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${this.token}`, // Header de autenticação
              'Accept': 'application/json' // Aceita resposta JSON
            },
            body: data
          })
            .then(response => {
              console.log('Resposta do servidor:', response)
              if (response.status >= 200 && response.status < 300) {
                return response
              } else {
                const error = new Error(response.statusText)
                error.response = response
                throw error
              }
            })
            .then(response => response.json())
            .then(data => {
              done({ progress: 100, url: data.image_header })
            })
            .catch(error => {
              done({ progress: 0, error: error.message })
            })
        })
      }, 1000)
    },
    copyVariable (variable) {
      navigator.clipboard.writeText(variable).then(() => {
        successMessage('Copiado: ' + variable, 1500)
      }).catch(() => {
        const el = document.createElement('textarea')
        el.value = variable
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        successMessage('Copiado: ' + variable, 1500)
      })
    },
    cancelar () {
      this.$router.push({
        name: 'settings-emails'
      })
    },
    async sendNotifications () {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, NOTIFICAR TODOS USUARIOS!'
      }).then(async result => {
        if (result.value) {
          try {
            await service.sendNotification().then(res => {
              let message = 'Sucesso: Em alguns minutos os e-mails serão enviados'
              let delay = 2500
              successMessage(message, delay)
              // this.close()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
              this.loading = false
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    // Busca as variáveis dos campos do form builder e injeta no editor.
    async loadVariables () {
      try {
        const res = await service.variables()
        const fields = (res.data && res.data.form_fields) ? res.data.form_fields : []
        const map = {}
        fields.forEach((v) => {
          // v.variable = '{$campo.empresa}', v.label = 'Empresa'
          const key = v.variable.replace(/[^a-z0-9_]/gi, '_')
          map[key] = { name: v.label, value: v.variable }
        })
        this.formFieldTags = map
        this.applyMergeTags()
      } catch (e) {
        this.formFieldTags = {}
      }
    },
    // Une as merge tags fixas com o grupo "Campos do formulário".
    buildMergeTags () {
      const tags = { ...this.options.mergeTags }
      if (this.formFieldTags && Object.keys(this.formFieldTags).length) {
        tags.campos_formulario = {
          name: 'Campos do formulário',
          mergeTags: this.formFieldTags
        }
      }
      return tags
    },
    // Aplica as merge tags no editor (só após ele estar pronto).
    applyMergeTags () {
      const editor = this.$refs.emailEditor && this.$refs.emailEditor.editor
      if (!editor || typeof editor.setMergeTags !== 'function') {
        return
      }
      editor.setMergeTags(this.buildMergeTags())
    },
    async loadItem () {
      if (this.$route.params.id) {
        let loader = this.$loading.show()
        try {
          await this.fetch(this.$route.params.id)
          this.emailtemplate = { ...this.data }
          if (!this.emailtemplate.design) {
            console.warn('Nenhum design retornado pelo backend, inicializando vazio')
            this.emailtemplate.design = {}
          }
        } catch (err) {
          console.error('Erro ao carregar item:', err)
          errorMessage('Alerta: Falha ao carregar o template')
        } finally {
          loader.hide()
        }
      }
    },
    popupEmailTest () {
      this.$refs.formTestEmail.open()
      this.modalForm = true
    },
    async saveEmailTemplate () {
      let loader = this.$loading.show()
      try {
        this.submitted = true
        await new Promise((resolve) => {
          this.$refs.emailEditor.editor.saveDesign((design) => {
            this.emailtemplate.design = design
            resolve()
          })
        })

        // Exporta o HTML e aguarda a conclusão
        await new Promise((resolve) => {
          this.$refs.emailEditor.editor.exportHtml((data) => {
            this.emailtemplate.content = data.html
            resolve()
          })
        })

        this.$v.emailtemplate.$touch()
        if (this.$v.emailtemplate.$invalid) {
          window.scroll(0, 0)
          loader.hide()
          errorMessage('Alerta: Existem campos obrigatórios não preenchidos')
          return
        }
        await this.createTemplate(this.emailtemplate).then(() => {
          let message = 'Sucesso: Dados atualizados com sucesso.'
          let delay = 2500
          successMessage(message, delay)
          this.cancelar()
          loader.hide()
        })
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
        loader.hide()
      }
    }
  },
  beforeDestroy () {
    if (this._mergeTagObserver) {
      this._mergeTagObserver.disconnect()
    }
  }
}
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.blockbuilder-branding { display: none }
.unlayer-editor { height: 1000px; margin: 10px}
.link { cursor: pointer; }
.preview-lg {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.logo-preview {
  width:200px;
  overflow:hidden;
  height: 65px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.bg-black { background-color: #afafaf; opacity: 1; }
.border-dashed {
  border: 2px dashed #ced4da !important;
  padding: 4px;
}
.vue-dropzone .dz-message {
  margin: 1em 0 !important;
}
.dropzone-custom-content {
  text-align: center;
}
.dropzone-custom-title {
  margin-top: 0;
  color: #0065b7;
  font-size: 18px;
}
.subtitle {
  color: #314b5f;
  font-size: 14px;
}
.footerEmail {
  text-align: center;
  padding: 5px;
  background: #F8F8FA;
  margin-bottom: 0.5rem;
}
.iconSocial {
  padding: 0;
    display: inline-block;
    height: auto;
    margin: 0;
}
.btn-trash {
  position: absolute;
  top: 10px;
  left: 20px;
}
.var-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: #f8f9fb;
  border: 1px solid #e2e5eb;
  border-radius: 5px;
  margin-bottom: 12px;
}
.var-bar-label {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
  white-space: nowrap;
}
.var-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #fff;
  border: 1px solid #e2e5eb;
  border-radius: 5px;
  font-size: 12px;
  color: #495057;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}
.var-tag:hover {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #3b82f6;
}
.var-tag code {
  font-size: 11px;
  color: #8b5cf6;
  background: transparent;
  padding: 0;
}
</style>
